module.exports = __webpack_public_path__ + "static/media/header-logo-academy.212362f8.webp";